import React                from 'react';
import { Observe }               from 'rewire-core';
import MainContentFooterPaging   from '../main-navigation/MainContentFooterPaging';
import { pageState }             from './DefaultSettingsView';

const ScheduleFooter = React.memo(() => {
  return <Observe render={() => {
    return pageState.__settings?.paging
             ? <MainContentFooterPaging model={pageState.__settings.paging} />
             : null;
  }} />;
});

export default ScheduleFooter;